export default __webpack_public_path__ + "static/media/lemontbotanique_l1.6a294de3.png";